import {
  FETCH_CARS,
  FETCH_CARS_SUCCESS,
  FETCH_CARS_FAILED,
  EDIT_CAR,
} from '../store/types';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import {
  onValue,
  update,
  set,
  child,
  remove,
  push,
  ref,
  get,
  getDatabase,
} from 'firebase/database';
import { uploadBytes, getDownloadURL } from 'firebase/storage';
import { deriveCarType, normalizeCarTypes } from '../other/carTypeFunctions';

export const fetchCars = () => dispatch => {
  const { carsRef } = firebase;

  dispatch({
    type: FETCH_CARS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;

  onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_CARS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_CARS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cars,
      });
    }
  });
};

export const addCar = car => async dispatch => {
  const { carAddRef } = firebase;
  const method = 'Add';

  dispatch({
    type: EDIT_CAR,
    payload: { method, car },
  });

  try {
    // Agregar el carro a la base de datos
    const newCarRef = push(carAddRef, car);

    // Obtener la clave única del carro recién agregado
    const newCarKey = newCarRef.key;
    return newCarKey;
  } catch (error) {
    console.error(error);
  }
};

export const uploadPictureToVehicleData = async (
  imageData,
  carUID,
  imageObjectKey,
) => {
  const { carImage, carEditRef } = firebase;
  await uploadBytes(carImage(carUID), imageData);
  let image = await getDownloadURL(carImage(carUID));
  update(carEditRef(carUID), {
    [imageObjectKey]: image,
  });
  return image;
};

export const editCar = (car, method) => async dispatch => {
  const { singleUserRef, carAddRef, carEditRef, carImage } = firebase;
  dispatch({
    type: EDIT_CAR,
    payload: { method, car },
  });

  if (method === 'Add') {
    push(carAddRef, car);
  } else if (method === 'Delete') {
    remove(carEditRef(car.id));
  } else if (method === 'UpdateImage') {
    await uploadBytes(carImage(car.id), car.car_image);
    let image = await getDownloadURL(carImage(car.id));
    let data = car;
    data.car_image = image;
    set(carEditRef(car.id), data);
    if (car.active && car.driver) {
      update(singleUserRef(car.driver), {
        updateAt: new Date().getTime(),
        car_image: image,
      });
    }
  } else {
    set(carEditRef(car.id), car);
  }
};

export const updateUserCarWithImage =
  (newData, blob, refId = null) =>
  async dispatch => {
    const { carImage, carEditRef, carsRef, singleUserRef } = firebase;

    let uid = newData.id ? newData.id : null;

    if (uid === null) {
      onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
        if (snapshot.val()) {
          let data = snapshot.val();
          const arr = Object.keys(data).map(i => {
            data[i].id = i;
            return data[i];
          });
          uid = arr.find(car => car.vehicleNumber === newData.vehicleNumber)[0]
            .id;
        }
      });
    }

    try {
      const reponse = await uploadBytes(carImage(uid), blob);
      const imgUrl = await getDownloadURL(carImage(uid));
      if (newData.active) {
        let updateData = {
          ...newData,
          car_image: imgUrl,
          updateAt: new Date().getTime(),
        };

        await update(singleUserRef(newData.driver), {
          carId: uid,
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info,
          car_image: imgUrl,
          carApproved: newData.approved,
          vehicleCity: newData.vehicleCity,
          updateAt: new Date().getTime(),
        });
        await update(carEditRef(uid), updateData);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const updateDriveCarInfoOnUserRef = async (carData, driverId) => {
  const { carImage, carEditRef, carsRef, singleUserRef } = firebase;

  try {
    let updateData = {
      carId: carData.UID,
      carType: 'taxi',
      car_image: carData.car_image,
      vehicleNumber: carData.vehicleNumber,
      vehicleMake: carData.vehicleMake,
      vehicleModel: carData.vehicleModel,
      other_info: carData.other_info,
      carApproved: carData.approved,
      vehicleCity: carData.vehicleCity,
    };
    await update(singleUserRef(driverId), updateData);
  } catch (error) {
    console.error(error);
  }
};

export const updateCarData = newCarData => async dispatch => {
  const { carImage, carUidRef, singleUserRef } = firebase;

  let uid = newCarData.id ? newCarData.id : null;

  try {
    let updateData = {
      vehicleNumber: newCarData.vehicleNumber,
      vehicleMake: newCarData.vehicleMake,
      vehicleModel: newCarData.vehicleModel,
      other_info: newCarData.other_info,
      carApproved: newCarData.approved,
      vehicleCity: newCarData.vehicleCity,
      vehicleReference: newCarData.vehicleReference,
      updateAt: new Date().getTime(),
    };

    // Clasificación de tier(s) — SÓLO la escribe la administración web.
    // `carTypes` presente en el payload ⇒ el admin editó la clasificación:
    //   - arreglo con valores  → ese/esos tier(s), y carType = carTypes[0]
    //   - vacío / null         → se limpia (el vehículo vuelve a atender todos)
    // `carTypes` ausente ⇒ no se toca la clasificación; sólo se refresca
    // `carType` (legacy) si vino explícito.
    if (Object.prototype.hasOwnProperty.call(newCarData, 'carTypes')) {
      const normalized = normalizeCarTypes(newCarData.carTypes);
      updateData.carTypes = normalized;
      updateData.carType = deriveCarType(normalized, newCarData.carType);
    } else if (newCarData.carType !== undefined) {
      updateData.carType = newCarData.carType;
    }

    if (newCarData.carImgBlob) {
      await uploadBytes(carImage(uid), newCarData.carImgBlob);
      const imgUrl = await getDownloadURL(carImage(uid));
      updateData.car_image = imgUrl;
    }

    // Firebase rechaza `undefined`: quitamos esas claves para no tocar esos
    // paths (p. ej. `carApproved` cuando el form de edición no lo incluye).
    Object.keys(updateData).forEach(k => {
      if (updateData[k] === undefined) delete updateData[k];
    });

    await update(singleUserRef(newCarData.driver), {...updateData, carId: uid});
    await update(carUidRef(uid), updateData);
  } catch (error) {
    console.error(error);
  }
};

export const updateCarAprroval = (carId, approved) => async dispatch => {
  const { carUidRef } = firebase;
  try {
    await update(carUidRef(carId), {
      carApproved: approved,
    });
  } catch (error) {
    console.error(error);
  }
};

// Lecturas puntuales: `get()` en vez de `onValue()` para no dejar listeners
// permanentes colgados cada vez que se abre una ficha de vehículo.
export const getCarData = async carId => {
  const { carRef } = firebase;
  try {
    const snapshot = await get(carRef(carId));
    return snapshot.val() || null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getCarDataByCarIUID = async carId => {
  const { carUidRef } = firebase;
  try {
    const snapshot = await get(carUidRef(carId));
    return snapshot.val() || null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getCarDataByDriverId = async driverId => {
  const { carRef } = firebase;
  try {
    const snapshot = await get(carRef(driverId));
    return snapshot.val() || null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

